import { useState } from "react";
import { ContentContainer, PageLayout } from "components/layout";
import { CampaignType } from "@/constants/campaign-types";
import { CreatePro013Form } from "./components/create-pro013-form";
import CreatePro014Form from "./components/create-pro014-form";
import CreatePro017Form from "./components/create-pro017-form";

export function CreateCampaign() {
  const [selectedType, setSelectedType] = useState<CampaignType>(CampaignType.PRO017);

  const handleChangeType = (type: CampaignType) => {
    setSelectedType(type);
  };

  return (
    <PageLayout>
      <ContentContainer>
        {selectedType === CampaignType.PRO013 && (
          <div className="space-y-4">
            <CreatePro013Form onChangeType={handleChangeType} />
          </div>
        )}

        {selectedType === CampaignType.PRO014 && (
          <div className="space-y-4">
            <CreatePro014Form onChangeType={handleChangeType} />
          </div>
        )}

        {selectedType === CampaignType.PRO017 && (
          <div className="space-y-4">
            <CreatePro017Form onChangeType={handleChangeType} />
          </div>
        )}
      </ContentContainer>
    </PageLayout>
  );
}
